


export const findPermission = (userData, permissionName) => {

    const permission = userData?.permissions?.find(value => value.module === permissionName)?.isAllowed
    return permission
}